import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { css } from 'emotion';

// Component
import { Input } from '@maxmilhas/hangar-components-atomic/public';

// Style
import * as cs from './style';

//Data
import * as dt from './data';

const getResults = value =>
  axios.get(`https://www.maxmilhas.com.br/airports/search/${value}`);

const AutocompleteAirports = ({
  id,
  name,
  onChange,
  placeholder,
  popularsTitle,
  label,
  returnIata,
  value
}) => {
  const [search, setSearch] = useState('');
  const [selectedAirport, setSelectedAirport] = useState(null);
  const [results, setResults] = useState({ data: dt.defaultResults });
  const [toggle, setToggle] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    let isSubscribed = true;
    const getAirport = async value => {
      const { data } = await getResults(value);
      const airport = data.find(airport => airport.iata === value);
      if (isSubscribed) {
        setSelectedAirport(airport);
      }
    };

    if (value) {
      if (typeof value === 'object') {
        setSelectedAirport(value);
      } else {
        getAirport(value);
      }
    }

    const handleClick = e => {
      if (inputRef.current.contains(e.target)) return;
      setToggle(false);
    };

    document.addEventListener('mousedown', handleClick);

    return () => {
      isSubscribed = false;
      document.removeEventListener('mousedown', handleClick);
    };
  }, []);

  useEffect(() => {
    let isSubscribed = true;
    const useSearch = async () => {
      if (search.length < 3)
        return setResults({ data: dt.defaultResults, search });
      const { data } = await getResults(search);
      if (isSubscribed) {
        setResults({ data, search });
      }
    };

    useSearch();

    return () => {
      isSubscribed = false;
    };
  }, [search]);

  useEffect(() => {
    if (selectedAirport) {
      setSearch(`${selectedAirport.iata} - ${selectedAirport.city}`);
    } else {
      setSearch('');
    }
  }, [selectedAirport]);

  useEffect(() => {
    if (!toggle) {
      if (selectedAirport) {
        setSearch(`${selectedAirport.iata} - ${selectedAirport.city}`);
      } else {
        setSearch('');
      }
    }
  }, [toggle]);

  const onSelect = result => {
    onChange(returnIata ? result.iata : result);
    setSelectedAirport(result);
    setToggle(false);
  };

  const onFocus = () => {
    setToggle(true);
    setSearch('');
  };

  // eslint-disable-next-line react/prop-types
  const Autocomplete = ({ isMobile }) => (
    <form
      autoComplete='off'
      onSubmit={e => {
        e.preventDefault();
      }}
    >
      <Input
        id={`${id}-${isMobile ? 'mobile' : 'desktop'}`}
        name={`${name}-${isMobile ? 'mobile' : 'desktop'}`}
        label={label}
        placeholder={placeholder}
        value={search}
        onChange={e => setSearch(e.target.value)}
        onFocus={onFocus}
        icon='icon-max-travel-plane'
      />
    </form>
  );

  return (
    <div ref={inputRef} className={css`${cs.componentWrapper}`}>
      {Autocomplete({ isMobile: false })}

      <div className={`${css`${cs.wrapper}`} ${toggle ? 'open' : 'close'}`}>
        {toggle && (
          <button
            type='button'
            className={css`${cs.deactivate}`}
            onClick={() => setToggle(false)}
          >
            <i className='icon-close' />
          </button>
        )}

        <div className={css`${cs.liveSearch}`}>
          <div className='inputMobile'>{Autocomplete({ isMobile: true })}</div>

          <div className={css`${cs.resultsWrapper}`}>
            {results.data && results.data.length > 0 ? (
              <>
                {(!results.search || results.search.length < 3) && (
                  <div className={css`${cs.popularTitle}`}>
                    <span className='placeholder'>{popularsTitle}</span>
                  </div>
                )}
                {results.data.map((result, i) => (
                  <Result
                    {...result}
                    term={results && results.search}
                    key={i}
                    onClick={() => onSelect(result)}
                  />
                ))}
              </>
            ) : (
              <p style={{ marginTop: 12 }}>
                Local não identificado, tente de outra forma
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

AutocompleteAirports.defaultProps = {
  placeholder: 'Cidade ou aeroporto',
  popularsTitle: 'Destinos mais buscados:',
  returnIata: true,
  onChange: () => undefined,
  label: 'Aeroporto',
  value: undefined
};

AutocompleteAirports.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  popularsTitle: PropTypes.string,
  returnIata: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      city: PropTypes.string.isRequired,
      iata: PropTypes.string.isRequired
    })
  ])
};

export const Result = ({ name, country, iata, city, term, ...rest }, i) => {
  const reg = term ? new RegExp(`(${term.trim()})`, 'ig') : null;
  const cityStr = reg ? city.replace(reg, '<span>$1</span>') : city;
  const iataStr = reg ? iata.replace(reg, '<span>$1</span>') : iata;
  const nameStr = name;
  const countryStr = `, ${country}` || '';

  return (
    <div className={css`${cs.result}`} key={i} {...rest}>
      <div className={css`${cs.flexWrapper}`}>
        <div
          className={css`${cs.iata}`}
          dangerouslySetInnerHTML={{ __html: iataStr }}
        />
        <div
          className={css`${cs.city}`}
          dangerouslySetInnerHTML={{
            __html: `${cityStr}, ${nameStr}${countryStr}`
          }}
        />
      </div>
    </div>
  );
};

Result.propTypes = {
  name: PropTypes.string,
  country: PropTypes.string,
  iata: PropTypes.string,
  city: PropTypes.string,
  term: PropTypes.string
};

export default AutocompleteAirports;
